function GetResolution() {
    return {
        height: window.screen.height,
        windowHeight: window.innerHeight,
        width: window.screen.width,
        windowWidth: window.innerWidth,
        depth: window.devicePixelRatio
    };
}

function Resolution() {
    const windowDetails = GetResolution();
    return (
        <div className="information_card">
            <h3>Screen resolution</h3>
            <p className="information" data-screen-details={windowDetails.width + ' x ' + windowDetails.height}>{windowDetails.width} x {windowDetails.height}</p>
        </div>
    );
}

export default Resolution;